import type { SessionUser } from '@cobliteam/common-types';
import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import GlobalSearch from '@cobliteam/global-search';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import InsightsButton from '@cobliteam/insights';
import { cn } from '@cobliteam/ui/utils';
import AppUserButton from '@cobliteam/ui-business/components/AppUser';
import { memo } from 'react';
import { SidebarTrigger } from '../AppSidebar';
import AIButton from './components/AIButton';
import FeedbackButton from './components/FeedbackButton';
import FilterGroupComponent from './components/FilterGroupComponent';
import { LanguageSwitcher } from './components/LanguageSwitcher';
import LogoComponent from './components/LogoComponent';
import NotificationsButton from './components/Notifications/NotificationsButton';

interface AppHeaderProps {
  user: SessionUser;
  logout: () => void;
}

const AppHeader = ({ user, logout }: AppHeaderProps) => {
  const { runtimeFlags } = useDashboard();
  const featureFlags = useFeatureFlags();

  return (
    <header
      data-testid='app-header'
      className={cn('sticky top-0 z-50 flex h-14 items-center justify-between gap-2 border-gray-6 border-b bg-white px-2 pl-4 shadow-sm transition-shadow duration-200')}
    >
      <div className='flex shrink-0 items-center justify-start gap-2'>
        <SidebarTrigger className='-ml-1 mr-2 desktop:hidden rounded-lg border border-gray-5' />
        <LogoComponent />
        <FilterGroupComponent />
      </div>

      <div className='flex items-center justify-end gap-2.5'>
        {!runtimeFlags.noValidGroupOrVehicles && <GlobalSearch />}
        {featureFlags.aiChat && <AIButton />}
        <InsightsButton />
        <FeedbackButton />
        <NotificationsButton />
        <LanguageSwitcher />
        <AppUserButton user={user} logout={logout} />
      </div>
    </header>
  );
};

export default memo(AppHeader, (prevProps, nextProps) => {
  return prevProps.user.id === nextProps.user.id;
});
